import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import SuccessModal from "../../../CustomAlerts/SuccessModal";
import ErrorModal from "../../../CustomAlerts/ErrorModal";
import { getPaymentStatus } from "../../../utils/apis/payment";
import { getPaymentHistoryList } from "../../../utils/apis/accountsApi";
import ProcessingModal from "./processingModal";

const SuccessPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const transaction_id = searchParams.get("TransactionID");

  // Selectors
  const { lastPaymentId } = useSelector((state) => state.accountMetrics.plans);
  const { idToken } = useSelector((state) => state.auth);
  const challengeId = useSelector(
    (state) => state.accountMetrics.plans.selected_challenge
  );

  // State
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState(null);

  // Message
  const successMessage =
    response?.data?.payment_status === "succeeded"
      ? "Congratulations! Payment was successful"
      : "You'll shortly receive an email with your account login credentials";
  console.log(lastPaymentId, "lastPaymentIdlastPaymentId");
  const verifyPaymentStatus = async () => {
    try {
      if (!lastPaymentId?.id) return;

      setIsLoading(true);

      const data = {
        payment_id: lastPaymentId?.id,
        ...(transaction_id && { transaction_id: transaction_id }),
      };

      // Simulate delay for payment processing
      await new Promise((resolve) => setTimeout(resolve, 10000));

      const responseAPI = await getPaymentStatus(idToken, data, dispatch);

      setResponse(responseAPI);

      if (responseAPI?.status === 200) {
        setPaymentStatus("success");
        await new Promise((resolve) => setTimeout(resolve, 3000));
        navigate("/billing-details/payment-history");
      } else {
        throw new Error("Payment status not successful");
      }

      dispatch(getPaymentHistoryList(idToken));
    } catch (error) {
      console.error("Error verifying payment status:", error);
      setPaymentStatus("failure");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    verifyPaymentStatus();
  }, [lastPaymentId?.id, idToken, dispatch]);

  const fetchNuvei = async () => {
    await fetch(
      `https://checkout-to-hyros-futures-871268446876.us-central1.run.app/checkout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          payment_status: lastPaymentId?.payment_status,
          payment_id: lastPaymentId?.id,
          email: lastPaymentId?.email,
          amount: lastPaymentId?.amount,
          currency: "USD",
        }),
      }
    );
  };

  useEffect(() => {
    if (
      lastPaymentId?.payment_mode === "nuvei" &&
      paymentStatus === "success"
    ) {
      fetchNuvei();
    }
  }, [lastPaymentId]);

  const renderModal = () => {
    if (isLoading) {
      return <ProcessingModal open={isLoading} />;
    }

    if (paymentStatus === "success") {
      return <SuccessModal title="Successful!" msg={successMessage} />;
    }

    return (
      <ErrorModal
        route={`/Assessments-checkout/${challengeId}`}
        msg={
          response?.detail === "Unable to fetch the payment status"
            ? "Payment is in progress, if successful you will receive your account in 15-30 mins"
            : "Payment Failed. Try again later."
        }
      />
    );
  };

  return <>{renderModal()}</>;
};

export default SuccessPayment;
